var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyes3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128.9 25.6",
    style: {
      enableBackground: "new 0 0 128.9 25.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000111184373555456641130000002714551546472889276_);}\n\t.st2{fill:url(#SVGID_00000112631579877973877860000012585941108952217227_);}\n\t.st3{fill:url(#SVGID_00000169558701145221065060000006874371255540694206_);}\n\t.st4{fill:#DD4C6A;}\n\t.st5{fill:#DD6B7C;}\n\t.st6{fill:#FFFFFF;}\n\t.st7{opacity:0.6;fill:#D177B8;enable-background:new    ;}\n\t.st8{fill:#4E1B3D;}\n\t.st9{fill:url(#SVGID_00000118396130240965847280000011615291028266078376_);}\n\t.st10{fill:url(#SVGID_00000041990892579667624770000017345115976246606514_);}\n\t.st11{fill:url(#SVGID_00000054973928859372905190000017639490478766120860_);}\n\t.st12{fill:url(#SVGID_00000047055713499677154760000001057353112260076983_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.7489,
    y1: 60.2202,
    x2: 138.7489,
    y2: 83.9726,
    gradientTransform: "matrix(0.9964 8.510000e-02 8.510000e-02 -0.9964 -35.6073 74.2664)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEE2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#BDC9FB"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.9,24.1C85.7,23.5,95,6.2,108.7,3.4c16.6-3.5,20.3,11.3,20.2,14.3C128.8,20.6,98.5,27.1,87.9,24.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183223048003887026500000011814988450989021885_",
    gradientUnits: "userSpaceOnUse",
    x1: 107.2,
    y1: 1.0244,
    x2: 107.2,
    y2: 22.5968,
    gradientTransform: "matrix(1 0 0 -1 0 25.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#471F4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#310A39"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000183223048003887026500000011814988450989021885_)"
    },
    cx: 107.2,
    cy: 14.1,
    r: 10.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013193162225845140370000006063830659605183157_",
    gradientUnits: "userSpaceOnUse",
    x1: 107.2,
    y1: 1.6553,
    x2: 107.2,
    y2: 21.9659,
    gradientTransform: "matrix(1 0 0 -1 0 25.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#57335B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#310A39"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000013193162225845140370000006063830659605183157_)"
    },
    cx: 107.2,
    cy: 14.1,
    r: 10.2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136384806309552456630000017729931197693343139_",
    gradientUnits: "userSpaceOnUse",
    x1: 107.2,
    y1: 5.2214,
    x2: 107.2,
    y2: 18.3998,
    gradientTransform: "matrix(1 0 0 -1 0 25.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88629B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#1B0023"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000136384806309552456630000017729931197693343139_)"
    },
    cx: 107.2,
    cy: 14.1,
    r: 6.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M88.4,20.6c0,0,6.8-18.2,21.9-20.4s18,14.1,18,14.1s-3.6-11.7-17.9-10.9C96.1,4.1,88.4,20.6,88.4,20.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M88,21.5l2.4,3c0,0-3.1,0.3-3.4-0.6C86.7,23.2,88,21.5,88,21.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M92.5,24.8c0,0,11.9,1.8,22.1-0.2c10.3-2,13.7-6.2,13.7-6.2S112.2,24.5,92.5,24.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M114.8,12c-0.7,0.6,2.4,0.7,4.6-0.2c2-0.8,3-2.1,2.8-2.3C122.1,9.3,117.4,9.7,114.8,12z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M113.1,12.6c-0.9-0.3-1.9,0.2-1.9,0.6c0,0.5,1,1,1.5,0.8C113.2,13.9,113.6,12.8,113.1,12.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M88,21.5c0,0,9.2-12.2,21.1-14.5s17.7,4.5,17.7,4.5s-1.7-8.7-17.3-7.6C93.9,5.1,88,21.5,88,21.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M88,21.5c0,0,7.2-16.2,23.3-17.3c14.4-1,17.4,11.6,17.4,11.6s1.5-11-8.4-13.6C110.9-0.3,94.7,4.7,88,21.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157276617728952506220000012914297293058602907_",
    gradientUnits: "userSpaceOnUse",
    x1: -1327.4683,
    y1: -65.0022,
    x2: -1327.4683,
    y2: -41.2497,
    gradientTransform: "matrix(-0.9964 8.510000e-02 -8.510000e-02 -0.9964 -1307.0328 74.2664)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEE2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#BDC9FB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157276617728952506220000012914297293058602907_)"
    },
    d: "M41.1,24.1C43.3,23.4,34,6.2,20.2,3.3 C3.6-0.2-0.1,14.6,0,17.6S30.4,27.1,41.1,24.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000901221233660182440000013749201041237826193_",
    gradientUnits: "userSpaceOnUse",
    x1: -1364.3402,
    y1: 1.0244,
    x2: -1364.3402,
    y2: 22.5968,
    gradientTransform: "matrix(-1 0 0 -1 -1342.6401 25.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#471F4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#310A39"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000000901221233660182440000013749201041237826193_)"
    },
    cx: 21.7,
    cy: 14.1,
    r: 10.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080173989028682981340000015914757705736448641_",
    gradientUnits: "userSpaceOnUse",
    x1: -1364.3402,
    y1: 1.6553,
    x2: -1364.3402,
    y2: 21.9659,
    gradientTransform: "matrix(-1 0 0 -1 -1342.6401 25.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#57335B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#310A39"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000080173989028682981340000015914757705736448641_)"
    },
    cx: 21.7,
    cy: 14.1,
    r: 10.2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078024334204952077650000001817572540983097763_",
    gradientUnits: "userSpaceOnUse",
    x1: -1364.3402,
    y1: 5.2214,
    x2: -1364.3402,
    y2: 18.3998,
    gradientTransform: "matrix(-1 0 0 -1 -1342.6401 25.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88629B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#1B0023"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000078024334204952077650000001817572540983097763_)"
    },
    cx: 21.7,
    cy: 14.1,
    r: 6.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M40.5,20.6c0,0-6.8-18.2-21.9-20.4C3.4-2,0.6,14.3,0.6,14.3S4.1,2.6,18.5,3.4C32.8,4.1,40.5,20.6,40.5,20.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M40.9,21.5l-2.4,3c0,0,3.1,0.3,3.4-0.6S40.9,21.5,40.9,21.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M36.4,24.8c0,0-11.9,1.8-22.1-0.2C4,22.6,0.6,18.4,0.6,18.4S16.7,24.5,36.4,24.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M14.1,12c0.7,0.6-2.4,0.7-4.6-0.2c-2-0.8-3-2.1-2.8-2.3C6.9,9.3,11.5,9.7,14.1,12z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M15.8,12.6c0.9-0.3,1.9,0.2,1.9,0.6c0,0.5-1,1-1.5,0.8C15.7,13.9,15.3,12.8,15.8,12.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M40.9,21.5c0,0-9.2-12.2-21.1-14.5S2.1,11.5,2.1,11.5s1.7-8.7,17.3-7.6C35,5.1,40.9,21.5,40.9,21.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M40.9,21.5c0,0-7.2-16.2-23.3-17.3C3.2,3.2,0.2,15.8,0.2,15.8s-1.5-11,8.4-13.6C18-0.3,34.2,4.7,40.9,21.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes3);
export default __webpack_public_path__ + "static/media/Eyes3.9299462688022a97f7233c1f58f9f1a7.svg";
export { ForwardRef as ReactComponent };